module.exports = __webpack_public_path__ + "static/media/audience-preferred.c8d45991.svg";